import { render } from "./ThemeSettings.vue?vue&type=template&id=03cbd992&scoped=true"
import script from "./ThemeSettings.vue?vue&type=script&lang=js"
export * from "./ThemeSettings.vue?vue&type=script&lang=js"

import "./ThemeSettings.vue?vue&type=style&index=0&id=03cbd992&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03cbd992"]])

export default __exports__